<template>
  <Course></Course>
</template>

<script>
  import Course from '@/page/modules/course/detail'
  export default {
    components: { Course }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/course/model.vue